import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LoadingModule } from '../loading/loading.module';
import { LocationContextPanelModule } from '../location-context-panel/location-context-panel.module';
import { MaterialModule } from '../material/material.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { Pages } from '../pages.config';
import { TimeCounterModule } from '../time-counter/time-counter.module';
import { DockingCameraComponent } from './docking-camera/docking-camera.component';
import { DockingCommandsComponent } from './docking-commands/docking-commands.component';
import { DockingInfoComponent } from './docking-info/docking-info.component';
import { DockingFlightInfoComponent } from './docking-flight-info/docking-flight-info.component';
import { DockingService } from './docking.service';
import { DockingComponent } from './docking/docking.component';
import { GseStatusComponent } from './gse-status/gse-status.component';
import { DockingResolver } from './resolvers/docking.resolver';
import { DockingEffects } from './store/docking.effects';
import * as fromDocking from './store/docking.reducers';
import { CommandPinCodeComponent } from './command-pin-code/command-pin-code.component';
import { ConMonService } from './conmon/conmon.service';
import { MonitoringModeDialogComponent } from './conmon/monitoring-mode-dialog/monitoring-mode-dialog.component';

const dockingRoutes: Routes = [
    {
        path: Pages.docking.path,
        component: DockingComponent,
        resolve: {
            DockingResolver
        }
    },
    {
        path: '**',
        component: DockingComponent,
        resolve: {
            DockingResolver
        }
    }
];

@NgModule({
    declarations: [
        DockingComponent,
        DockingCommandsComponent,
        DockingInfoComponent,
        DockingFlightInfoComponent,
        DockingCameraComponent,
        GseStatusComponent,
        CommandPinCodeComponent,
        MonitoringModeDialogComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        LoadingModule,
        LocationContextPanelModule,
        TimeCounterModule,
        NotificationsModule,
        RouterModule.forChild(dockingRoutes),
        StoreModule.forFeature(fromDocking.dockingFeatureKey, fromDocking.dockingContextReducer, {
            metaReducers: fromDocking.metaReducers
        }),
        EffectsModule.forFeature([DockingEffects])
    ],
    providers: [DockingResolver, ConMonService]
})
export class DockingModule {}
